import { render } from "./Terms.vue?vue&type=template&id=65af672f&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"

import "./Terms.vue?vue&type=style&index=0&id=65af672f&scoped=true&lang=css"

import exportComponent from "../../../Mamolico/NcS02D02JpStore/WebApp/Mamolico/NcS02D02JpStore/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65af672f"]])

export default __exports__